import React from "react";
import { ConsoleRouteMap } from "../../routes/routes";
import { useEntity } from "../../context/entity";
import { EntityLevelType } from "./enum";
import { useLocation } from "react-router-dom";

export function useGetActiveEntityLevel(): EntityLevelType {
  const location = useLocation();
  const { programDetails, registrationDetails, eventSeriesDetails, clientDetails } = useEntity();

  return React.useMemo(() => {
    if (programDetails?.name && location.pathname.includes(`${ConsoleRouteMap.PROGRAM.path}/`)) {
      return EntityLevelType.PROGRAM;
    }
    if (registrationDetails?.name && location.pathname.includes(`${ConsoleRouteMap.REGISTRATION.path}/`)) {
      return EntityLevelType.REGISTRATION;
    }
    if (eventSeriesDetails?.name && location.pathname.includes(`${ConsoleRouteMap.EVENT_SERIES.path}/`)) {
      return EntityLevelType.EVENT_SERIES;
    }
    if (clientDetails?.name && location.pathname.includes(`${ConsoleRouteMap.CLIENT.path}/`)) {
      return EntityLevelType.CLIENT;
    }
    return EntityLevelType.HOME;
  }, [
    location.pathname,
    clientDetails?.name,
    eventSeriesDetails?.name,
    registrationDetails?.name,
    programDetails?.name
  ]);
}
